import UiPageLayout from "../../components/page-layout/PageLayout.component";
import { PageProps } from "../../models/routing.model";
import CareMessagesClient from "./care-messages/CareMessagesClient";

const Messages = (_props: PageProps) => {
	return (
		<UiPageLayout
			title="MESSAGES.TITLE"
			className="messages-container"
			rightChildren={<CareMessagesClient />}
		/>
	);
};
export default Messages;
